import { Dispatch } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'antd';

import { snapStore } from 'containers/Snaps/Snap/store';

import { usePostRequest, useUserRole } from 'hooks';

import { ProductLineItemMatch, ProductMatchesWithSnapState } from 'codegen';

import { handleRematchProducts } from '../lib';

interface IRematchButton {
  isRematchAllowed?: boolean;
  setMatchesData: Dispatch<ProductLineItemMatch[]>;
}

export const RematchButton = ({ isRematchAllowed, setMatchesData }: IRematchButton) => {
  const canHaveOfferMatches = snapStore((state) => state.snapBooleanStatuses.canHaveOfferMatches);

  const { snapId } = useParams();
  const { isAdmin } = useUserRole();

  const [postRematch, { loading }] = usePostRequest<ProductMatchesWithSnapState>({
    url: `/snaps/${snapId}/matches/rematch`,
    options: {
      onSuccess: handleRematchProducts(canHaveOfferMatches, setMatchesData),
    },
  });

  if (!isRematchAllowed || !isAdmin) {
    return null;
  }

  return (
    <Button
      loading={loading}
      onClick={() => postRematch()}
    >
      Rematch
    </Button>
  );
};
